import React from 'react';
import FindInPageRoundedIcon from '@material-ui/icons/FindInPageRounded';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import styles from './FormTreePanel.module.css';
import {
    caption
} from '../../redux/actions/lang';


const FormTreePanel = ( props ) => {

    if( !props.isVisible ) return '';
     
    return <Tooltip title = { caption.openFormTree } arrow>
        <IconButton
            color="primary"
            style={{ position: "fixed", top: "calc(50% - 20px)", left: "-5px", zIndex: "9000" }}
            onClick={ props.onOpenFormTree }
        >
            <FindInPageRoundedIcon fontSize="large" className={ styles.xxIcon } />
        </IconButton>
        </Tooltip>;
}

export default FormTreePanel;
